import StandardConsentMessage from './StandardConsentMessage'

export default StandardConsentMessage
